import React from "react";
import { fmtINR } from "../../lib/apiClient";

// Totals panel: subtotal, discounts, taxes, round-off, advance and grand total.
export function DocSummaryCard({ form, setForm, cfg, totals }) {
  return (
  <div className="card-base p-5">
    <div className="font-display font-semibold mb-4">Summary</div>
    <Row k="Subtotal" v={fmtINR(totals.subtotal)} />
    {totals.lineDiscount > 0 && <Row k="Line Discount" v={"- " + fmtINR(totals.lineDiscount)} />}
    {/* Doc-level extra discount */}
    <div className="flex items-center justify-between py-2 my-1 border-y border-dashed border-border">
      <div className="flex items-center gap-2">
        <span className="text-xs text-ink-muted">Extra Discount</span>
        <select className="field !py-1 !px-1.5 !text-xs" style={{ width: 70 }} value={form.extra_discount_type} onChange={e => setForm({ ...form, extra_discount_type: e.target.value })} data-testid="extra-discount-type">
          <option value="amount">₹</option>
          <option value="pct">%</option>
        </select>
        <input type="number" step="0.01" className="field !py-1 !px-1.5 !text-xs text-right" style={{ width: 90 }} value={form.extra_discount_value} onChange={e => setForm({ ...form, extra_discount_value: e.target.value })} data-testid="extra-discount-value" />
      </div>
      <span className="tabular text-sm font-semibold text-destructive">{totals.extraDiscount > 0 ? "- " + fmtINR(totals.extraDiscount) : "—"}</span>
    </div>
    <Row k="Taxable Value" v={fmtINR(totals.totalTaxable)} />
    {cfg.showTax && (totals.isInterState
      ? <Row k="IGST" v={fmtINR(totals.igst)} />
      : <><Row k="CGST" v={fmtINR(totals.cgst)} /><Row k="SGST" v={fmtINR(totals.sgst)} /></>
    )}
    {Math.abs(totals.roundOff) > 0.0001 && (
      <Row k="Round Off" v={`${totals.roundOff > 0 ? "+ " : "- "}${fmtINR(Math.abs(totals.roundOff))}`} />
    )}
    {totals.advanceApplied > 0 && (
      <>
        <Row k="Total" v={fmtINR(totals.grandPreAdvance)} />
        <Row k="Advance Adjusted" v={"- " + fmtINR(totals.advanceApplied)} />
      </>
    )}
    <div className="border-t border-border mt-3 pt-3 flex items-center justify-between">
      <div className="label-overline">{totals.advanceApplied > 0 ? "Balance Payable" : "Grand Total"}</div>
      <div className="font-display text-2xl font-bold tabular" data-testid="doc-grand-total">{fmtINR(totals.grand)}</div>
    </div>
  </div>
  );
}

function Row({ k, v }) {
  return (
    <div className="flex items-center justify-between py-1.5 text-sm">
      <span className="text-ink-muted">{k}</span>
      <span className="tabular font-semibold">{v}</span>
    </div>
  );
}
